import App from 'next/app';
import getConfig from 'next/config';
import sentry from '../utils/sentry';
import ErrorPage from './_error.jsx';
import { AuthProvider } from '../auth/index.js';
import Inter from '../public/static/inter/inter.css';
import normalizeCss from 'normalize.css/normalize.css';

const { publicRuntimeConfig } = getConfig();

const { Sentry, captureException } = sentry();

export default class MyApp extends App {
  constructor() {
    super(...arguments);

    this.state = {
      hasError: false,
      errorStatusCode: undefined,
      errorEventId: undefined,
    };
  }

  static async getInitialProps({ Component, ctx }) {
    try {
      let pageProps = {};

      if (Component.getInitialProps) {
        pageProps = await Component.getInitialProps(ctx);
      }

      return { pageProps };
    } catch (error) {
      if (error.isAxiosError) {
        if (!ctx.errorInfo) {
          ctx.errorInfo = [];
        }

        ctx.errorInfo.push(error.response.data);

        error.message = `${error.message} [${error.response.data}]`;
      }

      if (!publicRuntimeConfig.isProduction) {
        throw error;
      }

      const errorStatusCode =
        error.isAxiosError && error.response ? error.response.status : 500;

      if (ctx.res) {
        ctx.res.status(errorStatusCode);
      }

      const errorEventId =
        errorStatusCode !== 404 ? captureException(error, ctx) : undefined;

      return {
        hasError: true,
        errorStatusCode,
        errorEventId,
      };
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {
      hasError: props.hasError || state.hasError || false,
      errorStatusCode:
        props.errorStatusCode || state.errorStatusCode || undefined,
      errorEventId: props.errorEventId || state.errorEventId || undefined,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    return (
      <>
        {this.state.hasError ? (
          <ErrorPage
            statusCode={this.state.errorStatusCode}
            errorEventId={this.state.errorEventId}
          />
        ) : (
          super.render()
        )}
      </>
    );
  }
}
